import "./AddAgency.css";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { FaEye, FaPen, FaPencilAlt } from "react-icons/fa"
import { FaSave } from "react-icons/fa";
import { FaEraser } from "react-icons/fa";
import { FaPlus, FaTimes } from "react-icons/fa";
import { IoIosStar } from "react-icons/io";
import { useState, useEffect, useRef } from "react";
import { RiDeleteBin3Fill } from "react-icons/ri";
import AddAgencyLogic from "./addAgencyLogic";
import { MdEdit } from "react-icons/md";
const AddAgency = () => {
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMonthDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    const {
        openSection, setOpenSection,
        file, setFile,
        jsonInput, jsonError,
        errors,

        agencyID, setAgencyID,
        agencyName, setAgencyName,
        datasetID, setDatasetID,
        agencyDisplayID, setAgencyDisplayID,
        agencyDisplayName, setAgencyDisplayName,
        agencyCountyName, setAgencyCountyName,
        agencyPhoneNumbers, setAgencyPhoneNumbers,
        addPhoneNumber, updatePhoneNumber, setPrimaryPhone,
        agencyContactPerson, setAgencyContactPerson,
        agencyDepartment, setAgencyDepartment,
        handledBy, setHandledBy, handledByUser, setHandledByUser, handledByUserEmail, setHandledByUserEmail, isActive, setIsActive,

        // addressName, setAddressName,
        addressLine, setAddressLine,
        city, setCity,
        stateVal, setStateVal,
        zip, setZip,

        smtpSubject, setSmtpSubject,
        datasets,
        emails,
        addEmail,
        removeEmail,
        updateEmail,

        toggleSection,
        handleBack,
        handleJsonInput,
        handleClearFile,
        handleFinalSave, reqMethod,
        setReqMethod,
        handleReqMethodChange,
        priority,
        setPriority,

        setErrors,

        // Fax
        faxList,
        setFaxList,
        addFax,
        removeFax,

        // Email
        emailList,
        setEmailList,
        emailRemove,

        // Snail Mail
        snailEmailList,
        setSnailEmailList,
        addSnailEmail,
        removeSnailEmail,
        snailName,
        setSnailName,
        snailAddress,
        setSnailAddress,
        snailCity,
        setSnailCity,
        snailState,
        setSnailState,
        snailZip,
        setSnailZip,

        // Drop Off
        dropOffEmails,
        setDropOffEmails,
        addDropoffEmail,
        removeDropoffEmail,
        dropName,
        setDropName,
        dropAddress,
        setDropAddress,
        dropCity,
        setDropCity,
        dropState,
        setDropState,
        dropZip,
        setDropZip,
        addEmailReq,
        // Agency Website + CrashDocs
        agenEmail,
        setAgenEmail,
        agenUrl,
        setAgenUrl,
        agenDescription,
        setAgenDescription,
        crashEmail,
        setcrashEmail,
        crashUrl,
        setcrashUrl,
        crashDescription,
        setcrashDescription,
        mongoId,
        // Response Method
        responseMethod,
        setResponseMethod,

        // Trigger Events
        triggerEvents,
        setTriggerEvents,

        // Frequency
        frequencyType,
        setFrequencyType,
        selectedWeekDays,
        setSelectedWeekDays,
        selectedMonthDays,
        setSelectedMonthDays,
        showMonthDropdown,
        setShowMonthDropdown,
        weekdays,
        monthDays,
        toggleWeekDay,
        toggleMonthDay,
        time,
        setTime,

        // Date Range
        dateRange,
        setDateRange,
        handleFileChange,
        filePreview,
        clearFieldError,
        handleFrequencyChange,
        snailEmailErrors,
        setSnailEmailErrors,
        dropoffEmailErrors,
        setDropoffEmailErrors,
        faxErrors,
        setFaxErros,
        emailReqErrors,
        setEmailReqErrors,
        acroFieldsTab,
        setAcroFieldsTab,
        acroFieldsList,
        setAcroFieldsList,
        syncAcroListToJson,
        syncAcroJsonToList,
        handleDeleteAcroField,
        handleResMethodChange, resEmailList, setResEmailList, resSnailName, setResSnailName, resSnailEmailList,
        setResSnailEmailList, resFaxList, setResFaxList,
        resSnailAddress, setResSnailAddress, resSnailCity,
        setResSnailCity, resSnailState,
        setResSnailState, resSnailZip, setResSnailZip,
        resPickupEmails, setResPickupEmails, resPickupName, setResPickupName,
        resPickupAddress, setResPickupAddress, resPickupCity, setResPickupCity,
        resPickupState, setResPickupState, resPickupZip, setResPickupZip, resAgenEmail,
        setResAgenEmail,
        resAgenUrl, setResAgenUrl, resAgenDescription, setResAgenDescription,
        resCrashEmail, setResCrashEmail, resCrashUrl, setResCrashUrl,
        resCrashDescription, setResCrashDescription, removeResFax, addResFax, removeResEmail, addResEmail, removeResSnailEmail, addResSnailEmail,
        addResPickupEmail, removeResPickupEmail, markDirty, selectedDataset, setSelectedDataset, entryType, docketType, setDocketType, dataSiteUrl, setDataSiteUrl, seqNo, setSeqNo
        , skipCount, setSkipCount, seqList, setSeqList, updateSeq, removeSeq, addSeq, isCounterBased, isDateRangeBased, isRequestBased,
        waitDaysBeforeSendingEmail, setWaitDaysBeforeSendingEmail, waitDaysBeforeCallingAgain, setWaitDaysBeforeCallingAgain, isCloneMode, generatePresignedUrl, handleOpenFileSection,
        datasetS3Key, generateUniversalPdfUrlOrSignature, pdfOption, setPdfOption, setFilePreview, setHasExistingFile, setIsDirty, agencie, fetchdatasetS3Key, handleCustomPdfClick, handleUniversalPdfClick,
        isJsonEditable, setIsJsonEditable
    } = AddAgencyLogic();






    return (
        <div className="main-content">
            <div className="p-2  custom-bg-white rounded d-flex justify-content-between align-items-center">
                <button className="back-btn " onClick={handleBack}>
                    <IoIosArrowBack /> Back
                </button>

                <div className="form-group add-agn-dataset">
                    <span className="datasetfield">Dataset</span>
                    <select
                        value={datasetID}
                        onChange={(e) => {
                            const value = e.target.value;
                            const selected = datasets.find(ds => ds.datasetID === value);
                            setDatasetID(value);
                            setSelectedDataset(selected);
                            localStorage.setItem("selectedDataset", value);
                            markDirty();
                            clearFieldError("datasetID");
                        }}
                        className={`form-select ${errors.datasetID ? "is-invalid" : ""}`}
                        disabled={!!mongoId}
                        required
                    >
                        <option value="">Select Dataset</option>

                        {datasets.map((ds) => (
                            <option key={ds.id} value={ds.datasetID}>
                                {ds.datasetName}
                            </option>
                        ))}
                    </select>

                    {errors.datasetID && <div className="error-text">{errors.datasetID}</div>}


                </div>

            </div>
            <div className="custom-bg-white main-content-2 mt-4 p-3 ">

                <div className="inner-content">
                    {/* PRIMARY DETAILS */}

                    {isRequestBased && (
                        <div className="accordion-item1">
                            <div className="accordion-header" onClick={() => toggleSection("primary")}>
                                <span>Primary Details</span>
                                <span>{openSection.includes("primary") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                            </div>

                            {openSection.includes("primary") && (
                                <div className="accordion-content">

                                    {/* Row 1 */}
                                    <div className="row">
                                        <div className="form-group input-section col">
                                            <label>Agency ID <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                value={agencyID}
                                                onChange={(e) => {

                                                    const value = e.target.value;
                                                    const limitedValue = value.slice(0, 50);

                                                    if (value.length > 50) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            agencyID: "Agency ID cannot exceed 50 characters"
                                                        }));
                                                    } else {
                                                        clearFieldError("agencyID");
                                                    }

                                                    setAgencyID(limitedValue);
                                                    markDirty();
                                                }}
                                                disabled={mongoId && !isCloneMode}
                                                style={mongoId && !isCloneMode ? { cursor: "not-allowed" } : {}}
                                                className={`form-control ${errors.agencyID ? "is-invalid" : ""}`}
                                                placeholder="Enter Agency Id"
                                            />
                                            {errors.agencyID && <div className="error-text">{errors.agencyID}</div>}

                                        </div>

                                        <div className="form-group input-section col">
                                            <label>Agency Name <span style={{ color: "red" }}>*</span></label>
                                            <input type="text"
                                                placeholder="Enter Agency Name"
                                                value={agencyName}
                                                onChange={(e) => {

                                                    const value = e.target.value;
                                                    const limitedValue = value.slice(0, 50);

                                                    if (value.length > 50) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            agencyName: "Agency Name cannot exceed 50 characters"
                                                        }));
                                                    } else {
                                                        clearFieldError("agencyName");
                                                    }

                                                    setAgencyName(limitedValue);
                                                    markDirty();
                                                }}
                                                className={`form-control ${errors.agencyName ? "is-invalid" : ""}`} />
                                            {errors.agencyName && <div className="error-text">{errors.agencyName}</div>}

                                        </div>
                                        <div className="form-group input-section col">
                                            <label>Agency Display ID <span style={{ color: "red" }}>*</span> </label>
                                            <input type="text" value={agencyDisplayID}
                                                onChange={(e) => {

                                                    const value = e.target.value;
                                                    const limitedValue = value.slice(0, 50);

                                                    if (value.length > 50) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            agencyDisplayID: "Agency Display ID cannot exceed 50 characters"
                                                        }));
                                                    } else {
                                                        clearFieldError("agencyDisplayID");
                                                    }

                                                    setAgencyDisplayID(limitedValue);
                                                    markDirty();
                                                }}
                                                className={`form-control ${errors.agencyDisplayID ? "is-invalid" : ""}`} placeholder="Enter Agency Display Id" />
                                            {errors.agencyDisplayID && <div className="error-text">{errors.agencyDisplayID}</div>}

                                        </div>

                                    </div>
                                    {/* Row 2 */}
                                    <div className="row">

                                        <div className="form-group input-section col" >
                                            <label>Agency Display Name <span style={{ color: "red" }}>*</span></label>
                                            <input type="text" value={agencyDisplayName}
                                                onChange={(e) => {

                                                    const value = e.target.value;
                                                    const limitedValue = value.slice(0, 50);

                                                    if (value.length > 50) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            agencyDisplayName: "Agency Display Name cannot exceed 50 characters"
                                                        }));
                                                    } else {
                                                        clearFieldError("agencyDisplayName");
                                                    }

                                                    setAgencyDisplayName(limitedValue);
                                                    markDirty();
                                                }} className={`form-control ${errors.agencyDisplayName ? "is-invalid" : ""}`} placeholder="Enter Agency Dispaly Name" />
                                            {errors.agencyDisplayName && <div className="error-text">{errors.agencyDisplayName}</div>}

                                        </div>

                                        <div className="form-group input-section col">
                                            <label>Agency County Name<span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                value={agencyCountyName}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const limitedValue = value.slice(0, 50);
                                                    if (value.length > 50) {
                                                        setErrors((prev) => ({
                                                            ...prev,
                                                            agencyCountyName: "Agency County Name cannot exceed 50 characters"
                                                        }));
                                                    } else {
                                                        clearFieldError("agencyCountyName");
                                                    }
                                                    setAgencyCountyName(limitedValue);
                                                    markDirty();
                                                }}
                                                className={`form-control ${errors.agencyCountyName ? "is-invalid" : ""}`}
                                                placeholder="Enter Agency County Name"
                                            />
                                            {errors.agencyCountyName && <div className="error-text">{errors.agencyCountyName}</div>}
                                        </div>

                                        <div className="form-group input-section col">
                                            <label>
                                                Address
                                            </label>
                                            <textarea

                                                className={`form-control agency-text-area-feild ${errors.addressLine ? "is-invalid" : ""}`}
                                                rows="2"
                                                placeholder="Enter Address"
                                                value={addressLine}
                                                onChange={(e) => {
                                                    setAddressLine(e.target.value);
                                                    markDirty();
                                                    clearFieldError("addressLine")
                                                }}

                                            ></textarea>
                                            {errors.addressLine && <div className="error-text">{errors.addressLine}</div>}

                                        </div>
                                    </div>





                                    {/* Row 3 */}

                                    <div className="row">
                                        {/* <div className="form-group input-section col">
                                        <label>
                                            Name<span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input type="text" value={addressName}
                                            onChange={(e) => { setAddressName(e.target.value); clearFieldError("addressName") }} className={`form-control ${errors.addressName ? "is-invalid" : ""}`} placeholder="Enter Name" />
                                        {errors.addressName && <div className="error-text">{errors.addressName}</div>}

                                    </div> */}

                                        {/* Phone */}
                                        <div className="form-group input-section col">
                                            <label>
                                                City
                                            </label>
                                            <input type="text" value={city}
                                                onChange={(e) => {
                                                    setCity(e.target.value);
                                                    markDirty();
                                                    clearFieldError("city");
                                                }} className={`form-control ${errors.city ? "is-invalid" : ""}`} placeholder="Enter City " />
                                            {errors.city && <div className="error-text">{errors.city}</div>}

                                        </div>

                                        <div className="form-group input-section col">
                                            <label>
                                                State
                                            </label>
                                            <input type="text" value={stateVal}
                                                onChange={(e) => {
                                                    setStateVal(e.target.value);
                                                    markDirty();
                                                    clearFieldError("stateVal")
                                                }} className={`form-control ${errors.stateVal ? "is-invalid" : ""}`} placeholder="Enter State" />
                                            {errors.stateVal && <div className="error-text">{errors.stateVal}</div>}

                                        </div>

                                        <div className="form-group input-section col">
                                            <label>
                                                Zip
                                            </label>
                                            <input type="text" value={zip}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                    setZip(value);
                                                    markDirty();
                                                    clearFieldError("zip");
                                                }}
                                                className={`form-control ${errors.zip ? "is-invalid" : ""}`} placeholder="Enter Zip" />
                                            {errors.zip && <div className="error-text">{errors.zip}</div>}

                                        </div>


                                    </div>
                                    {/* Row 4 */}
                                    <div className="row">

                                        <div className="form-group input-section col">
                                            <label>Agency Contact Person</label>
                                            <input type="text" value={agencyContactPerson}
                                                onChange={(e) => {
                                                    setAgencyContactPerson(e.target.value);
                                                    markDirty();
                                                    clearFieldError("agencyContactPerson")
                                                }} className={`form-control ${errors.agencyContactPerson ? "is-invalid" : ""}`} placeholder="Enter Agency Contact Person" />
                                            {errors.agencyContactPerson && <div className="error-text">{errors.agencyContactPerson}</div>}

                                        </div>

                                        <div className="form-group input-section col">
                                            <label>Agency Department</label>
                                            <input type="text" value={agencyDepartment}
                                                onChange={(e) => {
                                                    setAgencyDepartment(e.target.value);
                                                    markDirty();
                                                    clearFieldError("agencyDepartment")
                                                }} className={`form-control ${errors.agencyDepartment ? "is-invalid" : ""}`} placeholder="Enter Agency Department" />
                                            {errors.agencyDepartment && <div className="error-text">{errors.agencyDepartment}</div>}

                                        </div>

                                        <div className="form-group input-section col-md-4">
                                            <label>Handled By</label>
                                            <select value={handledBy}
                                                onChange={(e) => {
                                                    setHandledBy(e.target.value);
                                                    markDirty();
                                                    clearFieldError("handledBy")
                                                }}
                                                className={`form-select ${errors.handledBy ? "is-invalid" : ""}`}
                                                required
                                            >
                                                <option value="">Select Handling Type</option>
                                                <option>Handles own reports</option>
                                                <option>Handled by Lexis</option>
                                                <option>Handled by another town</option>
                                                <option>Handled by Trenton HQ</option>
                                                <option>Handled by state police</option>
                                                <option>Does not provide Data</option>
                                                <option>Provided by Legal Plex Partner</option>
                                                <option>Provided from website</option>
                                                <option>Handled by County</option>
                                            </select>
                                            {errors.handledBy && <div className="error-text">{errors.handledBy}</div>}

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group input-section col-md-4">
                                            <label>
                                                Smtp Settings - Subject
                                            </label>
                                            <textarea

                                                rows="2"
                                                placeholder="Enter Subject"
                                                value={smtpSubject}
                                                onChange={(e) => {
                                                    setSmtpSubject(e.target.value);
                                                    markDirty();
                                                    clearFieldError("smtpSubject")
                                                }}
                                                className={'form-control agency-text-area-feild '}
                                            ></textarea>

                                        </div>
                                        <div className="form-group input-section col-4" >
                                            <label>Handled By User </label>
                                            <input type="text" value={handledByUser} placeholder="Handled By User"
                                                onChange={(e) => {
                                                    setHandledByUser(e.target.value);
                                                    markDirty();
                                                    clearFieldError("handledByUser")
                                                }} className="form-control" />

                                        </div>
                                        <div className="form-group input-section col-4" >
                                            <label>Handled By User Email</label>
                                            <input type="text" value={handledByUserEmail} placeholder="Handled By User Email"
                                                onChange={(e) => {
                                                    setHandledByUserEmail(e.target.value);
                                                    markDirty();
                                                    clearFieldError("handledByUserEmail")
                                                }} className="form-control" />

                                        </div>
                                        <div className="form-group input-section col-4 d-flex flex-row align-items-center gap-2 mt-1">
                                            <input
                                                type="checkbox"
                                                style={{ transform: "scale(1.1)" }}
                                                checked={isActive}
                                                onChange={(e) => {
                                                    setIsActive(e.target.checked);
                                                    markDirty();
                                                }}
                                            />
                                            <label>Is Active</label>
                                        </div>
                                    </div>

                                </div>
                            )}

                        </div>
                    )}
                    <div>

                        {(isCounterBased || isDateRangeBased) && (

                            <div className="accordion-content">

                                {/* Row 1 */}
                                <div className="row">
                                    <div className="form-group input-section col">
                                        <label>Agency ID <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            value={agencyID}
                                            onChange={(e) => {

                                                const value = e.target.value;
                                                const limitedValue = value.slice(0, 50);

                                                if (value.length > 50) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        agencyID: "Agency ID cannot exceed 50 characters"
                                                    }));
                                                } else {
                                                    clearFieldError("agencyID");
                                                }

                                                setAgencyID(limitedValue);
                                                markDirty();
                                            }}
                                            disabled={mongoId && !isCloneMode}
                                            style={mongoId && !isCloneMode ? { cursor: "not-allowed" } : {}}
                                            className={`form-control ${errors.agencyID ? "is-invalid" : ""}`}
                                            placeholder="Enter Agency Id"
                                        />
                                        {errors.agencyID && <div className="error-text">{errors.agencyID}</div>}

                                    </div>

                                    <div className="form-group input-section col">
                                        <label>Agency Name <span style={{ color: "red" }}>*</span></label>
                                        <input type="text"
                                            placeholder="Enter Agency Name"
                                            value={agencyName}
                                            onChange={(e) => {

                                                const value = e.target.value;
                                                const limitedValue = value.slice(0, 50);

                                                if (value.length > 50) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        agencyName: "Agency Name cannot exceed 50 characters"
                                                    }));
                                                } else {
                                                    clearFieldError("agencyName");
                                                }

                                                setAgencyName(limitedValue);
                                                markDirty();
                                            }}
                                            className={`form-control ${errors.agencyName ? "is-invalid" : ""}`} />
                                        {errors.agencyName && <div className="error-text">{errors.agencyName}</div>}

                                    </div>

                                    <div className="form-group input-section col">
                                        <label>Agency Display ID <span style={{ color: "red" }}>*</span> </label>
                                        <input type="text" value={agencyDisplayID}
                                            onChange={(e) => {

                                                const value = e.target.value;
                                                const limitedValue = value.slice(0, 50);

                                                if (value.length > 50) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        agencyDisplayID: "Agency Display ID cannot exceed 50 characters"
                                                    }));
                                                } else {
                                                    clearFieldError("agencyDisplayID");
                                                }

                                                setAgencyDisplayID(limitedValue);
                                                markDirty();
                                            }}
                                            className={`form-control ${errors.agencyDisplayID ? "is-invalid" : ""}`} placeholder="Enter Agency Display Id" />
                                        {errors.agencyDisplayID && <div className="error-text">{errors.agencyDisplayID}</div>}

                                    </div>

                                    <div className="form-group input-section col" >
                                        <label>Agency Display Name <span style={{ color: "red" }}>*</span></label>
                                        <input type="text" value={agencyDisplayName}
                                            onChange={(e) => {

                                                const value = e.target.value;
                                                const limitedValue = value.slice(0, 50);

                                                if (value.length > 50) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        agencyDisplayName: "Agency Display Name cannot exceed 50 characters"
                                                    }));
                                                } else {
                                                    clearFieldError("agencyDisplayName");
                                                }

                                                setAgencyDisplayName(limitedValue);
                                                markDirty();
                                            }}
                                            className={`form-control ${errors.agencyDisplayName ? "is-invalid" : ""}`} placeholder="Enter Agency Dispaly Name" />
                                        {errors.agencyDisplayName && <div className="error-text">{errors.agencyDisplayName}</div>}

                                    </div>

                                    <div className="form-group input-section col">
                                        <label>Agency County Name<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            value={agencyCountyName}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const limitedValue = value.slice(0, 50);
                                                if (value.length > 50) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        agencyCountyName: "Agency County Name cannot exceed 50 characters"
                                                    }));
                                                } else {
                                                    clearFieldError("agencyCountyName");
                                                }
                                                setAgencyCountyName(limitedValue);
                                                markDirty();
                                            }}
                                            className={`form-control ${errors.agencyCountyName ? "is-invalid" : ""}`}
                                            placeholder="Enter Agency County Name"
                                        />
                                        {errors.agencyCountyName && <div className="error-text">{errors.agencyCountyName}</div>}
                                    </div>

                                </div>
                                {/* Row 2 */}
                                <div className="row">

                                    <div className="form-group input-section col-3" >
                                        <label>Data Site Url </label>
                                        <input type="text" value={dataSiteUrl}
                                            onChange={(e) => {
                                                setDataSiteUrl(e.target.value);
                                                markDirty();
                                                clearFieldError("dataSiteUrl")
                                            }} className="form-control" placeholder="Enter Datasite URL" />
                                        {/* {errors.dataSiteUrl && <div className="error-text">{errors.dataSiteUrl}
                                        </div>} */}

                                    </div>

                                    <div className="form-group input-section col-3" >
                                        <label>Docket Type </label>
                                        <input type="text" value={docketType} placeholder="Enter Docket Type"
                                            onChange={(e) => {
                                                setDocketType(e.target.value);
                                                markDirty();
                                                clearFieldError("docketType")
                                            }} className="form-control" />

                                    </div>

                                    <div className="form-group input-section col-3">
                                        <label>Consecutive skip count No.</label>
                                        <input
                                            type="text"
                                            value={skipCount}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                setSkipCount(value);
                                                markDirty();
                                                clearFieldError("skipCount");
                                            }}
                                            className="form-control" placeholder="Enter Skip Count"
                                        />

                                        {/* {errors.skipCount && (
                                            <div className="error-text">{errors.skipCount}</div>
                                        )} */}
                                    </div>

                                    <div className="form-group input-section col-3" >
                                        <label>Handled By User </label>
                                        <input type="text" value={handledByUser} placeholder="Handled By User"
                                            onChange={(e) => {
                                                setHandledByUser(e.target.value);
                                                markDirty();
                                                clearFieldError("handledByUser")
                                            }} className="form-control" />

                                    </div>
                                    {/* <div className="form-group input-section col-3" >
                                        <label>Handled By User Email</label>
                                        <input type="text" value={handledByUserEmail} placeholder="Handled By User Email"
                                            onChange={(e) => {
                                                setHandledByUserEmail(e.target.value);
                                                markDirty();
                                                clearFieldError("handledByUserEmail")
                                            }} className="form-control" />

                                    </div> */}
                                    <div className="form-group input-section col-3 d-flex flex-row align-items-center gap-2 mt-1">
                                        <input
                                            type="checkbox"
                                            style={{ transform: "scale(1.1)" }}
                                            checked={isActive}
                                            onChange={(e) => {
                                                setIsActive(e.target.checked);
                                                markDirty();
                                            }}
                                        />
                                        <label>Is Active</label>
                                    </div>

                                </div>
                                {/* Row 3 – Priority */}
                                <div className="row">
                                    <div className="form-group input-section col-3">
                                        <label>
                                            Priority
                                            {/* <span style={{ color: "red" }}>*</span> */}
                                        </label>
                                        <select
                                            value={priority}
                                            onChange={(e) => {
                                                setPriority(e.target.value);
                                                markDirty();
                                                clearFieldError("priority");
                                            }}
                                            className={`form-control ${errors.priority ? "is-invalid" : ""}`}
                                        >
                                            <option value="">Select Priority</option>
                                            <option value="high">High</option>
                                            <option value="medium">Medium</option>
                                            <option value="low">Low</option>
                                        </select>

                                        {errors.priority && (
                                            <div className="error-text">{errors.priority}</div>
                                        )}
                                    </div>
                                </div>
                                {isCounterBased && seqList.map((item, index) => (
                                    <div className="seq-row mb-2" key={index}>
                                        <div className="form-group input-section">
                                            <label>Year</label>
                                            <select
                                                value={item.year}
                                                onChange={(e) => updateSeq(index, "year", e.target.value)}
                                                className="form-control"
                                            >
                                                {[new Date().getFullYear(), new Date().getFullYear() - 1].map((yr) => (
                                                    <option key={yr} value={yr.toString()}>
                                                        {yr}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {/* {errors[`seqYear${index}`] && (
                                            <p className="error-text">{errors[`seqYear${index}`]}</p>
                                        )} */}



                                        {/* Sequence Number input */}
                                        <div className="form-group input-section">
                                            <label>Sequence Number</label>
                                            <input
                                                type="text"
                                                value={item.seqNo}
                                                onChange={(e) => updateSeq(index, "seqNo", e.target.value.replace(/\D/g, ""))}
                                                className="form-control"
                                                placeholder="Enter Sequence Number"
                                            />
                                        </div>


                                        {/* Add/Remove icons */}
                                        <div className="icon-add-year-seq">
                                            {seqList.length > 1 && (
                                                <FaTimes
                                                    className="seq-icon remove"
                                                    title="Remove"
                                                    onClick={() => removeSeq(index)}
                                                />
                                            )}
                                            {seqList.length < 2 && (
                                                <FaPlus
                                                    className="seq-icon add"
                                                    title="Add"
                                                    onClick={addSeq}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ))}

                                {isDateRangeBased && (
                                    <div className="seq-row mb-2">
                                        <div className="form-group input-section">
                                            <label>
                                                From <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="number"
                                                value={dateRange.from}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === "") {
                                                        setDateRange({ ...dateRange, from: "" });
                                                        clearFieldError("FromError");
                                                        return;
                                                    }
                                                    if (Number(value) >= 0) return;
                                                    setDateRange({ ...dateRange, from: value });
                                                    markDirty();
                                                    clearFieldError("FromError");
                                                }}
                                                max={0}
                                                className={`form-control ${errors.FromError ? "is-invalid" : ""}`}
                                                placeholder="Enter From Range"
                                            />
                                            {errors.FromError && (
                                                <div className="error-text">{errors.FromError}</div>
                                            )}
                                        </div>

                                        <div className="form-group input-section">
                                            <label>
                                                To <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="number"
                                                value={dateRange.to}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === "") {
                                                        setDateRange({ ...dateRange, to: "" });
                                                        clearFieldError("ToError");
                                                        return;
                                                    }
                                                    if (Number(value) > 0) return;
                                                    setDateRange({ ...dateRange, to: value });
                                                    markDirty();
                                                    clearFieldError("ToError");
                                                }}
                                                max={0}
                                                className={`form-control ${errors.ToError ? "is-invalid" : ""}`}
                                                placeholder="Enter To Range"
                                            />
                                            {errors.ToError && (
                                                <div className="error-text">{errors.ToError}</div>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </div>
                        )}
                    </div>


                    {/* ASSOCIATED EMAILS */}
                    {isRequestBased && (
                        <>
                            {/* PHONE NUMBERS */}
                            <div className="accordion-item1">
                                <div className="accordion-header" onClick={() => toggleSection("agencyPhoneNumbers")}>
                                    <span>Agency Phone Numbers</span>
                                    <span>{openSection.includes("agencyPhoneNumbers") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                                </div>
                                {openSection.includes("agencyPhoneNumbers") && (
                                    <div className="accordion-content">
                                        {agencyPhoneNumbers.map((phone, index) => (
                                            <div key={index} className="phone-row">
                                                <div style={{ display: "flex", flexDirection: "column", width: "430px" }}>
                                                    <input
                                                        type="text"
                                                        className={`form-control email-input phone-input ${errors[`phone_${index}`] ||
                                                            agencyPhoneNumbers.find(
                                                                (p, i) =>
                                                                    i < index &&
                                                                    p.number === phone.number &&
                                                                    phone.number
                                                            )
                                                            ? "is-invalid"
                                                            : ""
                                                            }`}
                                                        placeholder="Enter Phone Number"
                                                        value={phone.number}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                                            updatePhoneNumber(index, value);
                                                            clearFieldError(`phone_${index}`);
                                                        }}
                                                    />

                                                    {errors[`phone_${index}`] ? (
                                                        <div className="error-text1" style={{ marginTop: "3px" }}>
                                                            {errors[`phone_${index}`]}
                                                        </div>
                                                    ) : (
                                                        agencyPhoneNumbers.find(
                                                            (p, i) =>
                                                                i < index &&
                                                                p.number === phone.number &&
                                                                phone.number
                                                        ) && (
                                                            <div className="error-text1" style={{ marginTop: "3px" }}>
                                                                Duplicate phone numbers are not allowed
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                                <label className="primary-phone-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={phone.isPrimary}
                                                        onChange={() => setPrimaryPhone(index)}
                                                        className="primary-phone-checkbox"
                                                    />
                                                    Primary
                                                </label>
                                                {agencyPhoneNumbers.length > 1 && (
                                                    <button
                                                        className="delete-email-btn"
                                                        onClick={() => {
                                                            setAgencyPhoneNumbers(prev => {
                                                                const updated = prev.filter((_, i) => i !== index);
                                                                const hasPrimary = updated.some(p => p.isPrimary);
                                                                if (!hasPrimary && updated.length > 0) {
                                                                    updated[0] = { ...updated[0], isPrimary: true };
                                                                }
                                                                return updated;
                                                            });
                                                            markDirty();
                                                        }}
                                                        style={{ alignSelf: "center" }}
                                                    >
                                                        <FaTimes size={18} />
                                                    </button>
                                                )}
                                            </div>
                                        ))}
                                        <button className="add-email-btn phone-add-btn" onClick={addPhoneNumber} >  + Add Phone Number
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="accordion-item1">
                                <div className="accordion-header" onClick={() => toggleSection("emails")}>
                                    <span>Associated Emails</span>
                                    <span>{openSection.includes("emails") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                                </div>

                                {openSection.includes("emails") && (
                                    <div className="accordion-content">
                                        {emails.map((email, index) => (
                                            <div key={index} className="email-row" style={{ display: "flex", gap: "8px" }}>
                                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                    <input
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        value={email}
                                                        onChange={(e) => {
                                                            updateEmail(index, e.target.value);
                                                            markDirty();
                                                            clearFieldError(`email_${index}`);
                                                        }}
                                                        className={`form-control email-input ${errors[`email_${index}`] ? "is-invalid" : email ? "" : ""
                                                            }`}
                                                    />
                                                    {errors[`email_${index}`] && (
                                                        <div className="error-text" style={{ marginTop: "3px" }}>
                                                            {errors[`email_${index}`]}
                                                        </div>
                                                    )}
                                                </div>

                                                {emails.length > 1 && (
                                                    <button
                                                        className="delete-email-btn"
                                                        onClick={() => removeEmail(index)}
                                                        style={{ alignSelf: "center" }} // keeps the button vertically centered
                                                    >
                                                        <FaTimes size={18} />
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Add Email button stays BELOW all errors */}
                                        <button className="add-email-btn" onClick={addEmail} style={{ marginTop: "10px" }}>
                                            + Add Email
                                        </button>
                                    </div>



                                )}
                            </div>

                            <div className="accordion-item1">
                                <div className="accordion-header" onClick={handleOpenFileSection}>
                                    <span>File & JSON Details</span>
                                    <span>{openSection.includes("fileSection") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                                </div>

                                {openSection.includes("fileSection") && (
                                    <div className="accordion-content">
                                        {/* FILE UPLOAD SECTION */}
                                        <div className="pdf-radio-wrapper">

                                            <label className="pdf-radio-item">
                                                <input
                                                    type="radio"
                                                    name="pdfOption"
                                                    value="universal"
                                                    checked={pdfOption === "universal"}
                                                    onChange={handleUniversalPdfClick}
                                                />
                                                Global Form
                                            </label>

                                            <label className="pdf-radio-item">
                                                <input
                                                    type="radio"
                                                    name="pdfOption"
                                                    value="custom"
                                                    checked={pdfOption === "custom"}
                                                    onChange={handleCustomPdfClick}
                                                />
                                                Specific Form
                                            </label>

                                        </div>
                                        <div className="file-json-row">

                                            <div className="form-group input-section file-row">
                                                <label>Report Request Form FileUpload {mongoId && <span style={{ color: "red" }}> *</span>}</label>

                                                {pdfOption === "universal" ? (

                                                    <div className="file-row-inner">

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={datasetS3Key}
                                                            disabled
                                                        />

                                                        {datasetS3Key && (
                                                            <button
                                                                type="button"
                                                                className="file-btn-preview"
                                                                onClick={() => {
                                                                    if (datasetS3Key) {
                                                                        generateUniversalPdfUrlOrSignature(datasetS3Key);
                                                                    }
                                                                }}
                                                                title="Preview Universal PDF"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        )}

                                                    </div>

                                                ) : (
                                                    <div className="file-row-inner">
                                                        <input
                                                            id="fileUploadInput"
                                                            type="file"
                                                            className={`form-control file-input ${errors.fileUpload ? "is-invalid" : ""}`}
                                                            onChange={handleFileChange}
                                                        />
                                                        {file && (
                                                            <span className="selected-file-name">
                                                                {file.name.split('/').pop().replace('.pdf', '')}
                                                            </span>
                                                        )}
                                                        {file?.s3Key && (
                                                            <button
                                                                type="button"
                                                                className="file-btn-preview"
                                                                onClick={generatePresignedUrl}
                                                                title="Preview File"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        )}

                                                        {filePreview && !file?.s3Key && (
                                                            <button
                                                                type="button"
                                                                className="file-btn-preview"
                                                                onClick={() => window.open(filePreview, "_blank")}
                                                                title="Preview File"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        )}
                                                        {/* <button className="file-btn1" onClick={handleClearFile}>
                                                            <FaEraser /> Clear
                                                        </button> */}
                                                    </div>
                                                )}
                                                {errors.fileUpload && (
                                                    <div className="invalid-feedback d-block">
                                                        {errors.fileUpload}
                                                    </div>
                                                )}

                                            </div>

                                            {/* JSON/LIST TOGGLE TABS */}
                                            <div className="radio-group-add mb-3">
                                                <div className="json-list-tabs1">
                                                    <button
                                                        type="button"
                                                        className={`tab-btn1 ${acroFieldsTab === "json" ? "active" : ""}`}
                                                        onClick={() => {
                                                            syncAcroListToJson();
                                                            setAcroFieldsTab("json");
                                                        }}
                                                    >
                                                        JSON
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`tab-btn1 ${acroFieldsTab === "list" ? "active" : ""}`}
                                                        onClick={() => {
                                                            syncAcroJsonToList();
                                                            setAcroFieldsTab("list");
                                                        }}
                                                    >
                                                        LIST
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* JSON VIEW */}
                                        {acroFieldsTab === "json" && (
                                            <div className="form-group input-section">
                                                <label>AcroFields JSON</label>
                                                <div style={{ position: "relative", display: "inline-block", width: "100%" }}>

                                                    <textarea
                                                        className='form-control json-textarea'
                                                        placeholder='Enter JSON Object (Example: {"key":"value"})'
                                                        value={jsonInput}
                                                        disabled={!isJsonEditable}
                                                        onChange={(e) => {
                                                            handleJsonInput(e.target.value);
                                                            markDirty();
                                                            clearFieldError("jsonInput");
                                                        }}
                                                        rows={5}
                                                    ></textarea>
                                                    <FaPen
                                                        title={isJsonEditable ? "Lock JSON" : "Edit JSON"}
                                                        onClick={() => setIsJsonEditable(prev => !prev)}
                                                        className={`json-pencil-icon ${isJsonEditable ? "active" : ""}`}
                                                    />
                                                </div>

                                                {errors.jsonInput && (
                                                    <div className="invalid-feedback d-block">
                                                        {errors.jsonInput}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* LIST VIEW */}
                                        {acroFieldsTab === "list" && (
                                            <div style={{ marginTop: "20px" }}>
                                                <div className="list-header-row1">
                                                    <span
                                                        className="add-item-btn1"
                                                        onClick={() => {
                                                            setAcroFieldsList(prev => [
                                                                { key: "", value: "", _isNew: true },
                                                                ...prev
                                                            ]);
                                                            markDirty();
                                                        }}
                                                    >
                                                        <FaPlus size={16} />
                                                        Add Field
                                                    </span>
                                                </div>

                                                <table className="list-table1">
                                                    <colgroup>
                                                        <col style={{ width: "45%" }} />
                                                        <col style={{ width: "45%" }} />
                                                        <col style={{ width: "10%" }} />
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th>Field Name (Key)</th>
                                                            <th>Field Value</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {acroFieldsList.map((row, index) => {
                                                            //  Check if value is an S3 image key
                                                            const isS3ImageKey = typeof row.value === "string" &&
                                                                /\.(png|jpg|jpeg|gif|webp)$/i.test(row.value.trim());

                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input
                                                                            className="form-control list-input1"
                                                                            placeholder="e.g., firstname"
                                                                            value={row.key || ""}
                                                                            onChange={(e) => {
                                                                                const updated = [...acroFieldsList];
                                                                                updated[index].key = e.target.value;
                                                                                setAcroFieldsList(updated);
                                                                                markDirty();
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            className="form-control list-input1"
                                                                            placeholder="e.g., John"
                                                                            value={row.value || ""}
                                                                            onChange={(e) => {
                                                                                const updated = [...acroFieldsList];
                                                                                updated[index].value = e.target.value;
                                                                                setAcroFieldsList(updated);
                                                                                markDirty();
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div style={{ display: "flex", alignItems: "center", marginLeft: "10px" }}>
                                                                            {isS3ImageKey ? (
                                                                                //  Show ONLY eye icon for S3 image keys
                                                                                <FaEye
                                                                                    style={{ color: "var(--buttonColor)", cursor: "pointer" }}
                                                                                    size="16px"
                                                                                    title="Preview Signature"
                                                                                    onClick={() => generateUniversalPdfUrlOrSignature(row.value)}
                                                                                />
                                                                            ) : (
                                                                                //  Show ONLY delete icon for all other fields
                                                                                <RiDeleteBin3Fill
                                                                                    style={{ color: "#dc3545", cursor: "pointer" }}
                                                                                    size="16px"
                                                                                    title="Delete Field"
                                                                                    onClick={() => handleDeleteAcroField(index)}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/*RequestAndResponse  */}
                            <div className="accordion-item1">
                                <div className="accordion-header" onClick={() => toggleSection("request")}>
                                    <span>Request And Response</span>
                                    <span>{openSection.includes("request") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                                </div>

                                {openSection.includes("request") && (
                                    <div className="mt-2 add-content">
                                        {/* ==========================================
                                    REQUEST METHOD SECTION
                                ========================================== */}
                                        <div className="request-box">
                                            <label className="section-title">Request Method <span style={{ color: "red" }}>*</span></label>

                                            <div className="radio-group-add mt-3 mb-2">
                                                <label>
                                                    <input
                                                        type="radio" name="reqMethod" checked={reqMethod === "fax"} onChange={() => { handleReqMethodChange("fax"); clearFieldError("reqMethodError") }} />{" "} Fax
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio" name="reqMethod" checked={reqMethod === "emailReq"} onChange={() => { handleReqMethodChange("emailReq"); clearFieldError("reqMethodError") }} />{" "}
                                                    Email
                                                </label>
                                                <label>
                                                    <input type="radio" name="reqMethod" checked={reqMethod === "snail"} onChange={() => { handleReqMethodChange("snail"); clearFieldError("reqMethodError") }} />{" "}
                                                    Snail Mail
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio" name="reqMethod" checked={reqMethod === "dropoff"} onChange={() => { handleReqMethodChange("dropoff"); clearFieldError("reqMethodError") }} />{" "}
                                                    Drop Off
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio" name="reqMethod" checked={reqMethod === "agenweb"} onChange={() => { handleReqMethodChange("agenweb"); clearFieldError("reqMethodError") }}
                                                    />{" "}
                                                    Request on Agency Website
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio" name="reqMethod" checked={reqMethod === "crashdocx"} onChange={() => { handleReqMethodChange("crashdocx"); clearFieldError("reqMethodError") }}
                                                    />{" "}
                                                    Crash Docs
                                                </label>
                                            </div>

                                            {/* ======================
                                            FAX HANDLING
                                        ======================= */}
                                            {reqMethod === "fax" && (
                                                <div className="section-card mt-3">
                                                    <label>Fax Numbers <span style={{ color: "red" }}>*</span></label>
                                                    {faxList.map((fax, index) => (
                                                        <div className="multi-row" key={index}  >
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control ${errors[`fax_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text" placeholder="Enter Fax Number" value={fax}
                                                                    onChange={(e) => {
                                                                        const list = [...faxList];
                                                                        list[index] = e.target.value;
                                                                        setFaxList(list);
                                                                        markDirty();

                                                                        clearFieldError(`fax_${index}`);
                                                                    }} style={{ flex: 1 }} />

                                                                {errors[`fax_${index}`] && (
                                                                    <p className="error-text">{errors[`fax_${index}`]}</p>
                                                                )}
                                                            </div>
                                                            <div className="icon-col">

                                                                {faxList.length > 1 && (
                                                                    <FaTimes className="icon-remove" onClick={() => removeFax(index)} style={{ cursor: "pointer", color: "#f00" }} />)}
                                                                {index === faxList.length - 1 && (
                                                                    <FaPlus className="icon-add" onClick={addFax} style={{ cursor: "pointer", color: "#09c" }} />)}
                                                            </div>
                                                        </div>

                                                    ))}

                                                </div>
                                            )}

                                            {/* ======================
                                        EMAIL HANDLING
                                    ======================= */}
                                            {reqMethod === "emailReq" && (
                                                <div className="section-card mt-3">
                                                    <label>Email Addresses <span style={{ color: "red" }}>*</span></label>
                                                    {emailList.map((mail, index) => (
                                                        <div className="multi-row" key={index}  >
                                                            <div className="input-col">
                                                                <input
                                                                    type="email"
                                                                    placeholder="Email"
                                                                    value={mail}
                                                                    onChange={(e) => {
                                                                        const updated = [...emailList];
                                                                        updated[index] = e.target.value;
                                                                        setEmailList(updated);
                                                                        markDirty();
                                                                        clearFieldError(`emailReq_${index}`)
                                                                    }}
                                                                    className={`form-control ${errors[`emailReq_${index}`] ? "is-invalid" : ""}`}
                                                                    style={{ flex: 1 }}
                                                                />
                                                                {errors[`emailReq_${index}`] && (
                                                                    <p className="error-text">{errors[`emailReq_${index}`]}</p>
                                                                )}

                                                            </div>
                                                            <div className="icon-col">

                                                                {emailList.length > 1 && (
                                                                    <FaTimes className="icon-remove" onClick={() => emailRemove(index)} />
                                                                )}

                                                                {index === emailList.length - 1 && (
                                                                    <FaPlus className="icon-add"
                                                                        onClick={addEmailReq}
                                                                        style={{ cursor: "pointer", color: "#09c" }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            )}

                                            {/* ======================
                                        SNAIL MAIL HANDLING
                                    ======================= */}
                                            {reqMethod === "snail" && (
                                                <div className="section-card mt-3">
                                                    <label>Email <span style={{ color: "red" }}>*</span></label>

                                                    {snailEmailList.map((mail, index) => (
                                                        <div className="multi-row" key={index}>
                                                            {/* Input + error stacked vertically */}
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control inp ${errors[`snailEmail_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text"
                                                                    placeholder="Enter Email"
                                                                    value={mail}
                                                                    onChange={(e) => {
                                                                        const list = [...snailEmailList];
                                                                        list[index] = e.target.value;
                                                                        setSnailEmailList(list);
                                                                        markDirty();
                                                                        clearFieldError(`snailEmail_${index}`);

                                                                    }}
                                                                    style={{ flex: 1 }}
                                                                />
                                                                {errors[`snailEmail_${index}`] && (
                                                                    <p className="error-text">{errors[`snailEmail_${index}`]}</p>
                                                                )}
                                                            </div>

                                                            {/* Icons beside input */}
                                                            <div className="icon-col">
                                                                {snailEmailList.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeSnailEmail(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}
                                                                {index === snailEmailList.length - 1 && (
                                                                    <FaPlus className="icon-add" onClick={addSnailEmail}
                                                                        style={{ cursor: "pointer" }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}


                                                    {/* Remaining Snail Mail fields */}
                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>Name <span style={{ color: "red" }}>*</span></label>
                                                            <input type="text" className={`form-control inp ${errors.snailName ? "is-invalid" : ""}`}

                                                                value={snailName} placeholder="Enter Name" onChange={(e) => {
                                                                    setSnailName(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, snailName: "" }));

                                                                }} />
                                                            {errors.snailName && <p className="error-text">{errors.snailName}</p>}

                                                        </div>

                                                        <div className="col">
                                                            <label>Address <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.snailAddress ? "is-invalid" : ""}`}
                                                                type="text" value={snailAddress} placeholder="Enter Address"
                                                                onChange={(e) => {
                                                                    setSnailAddress(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, snailAddress: "" }));
                                                                }} />
                                                            {errors.snailAddress && <p className="error-text">{errors.snailAddress}</p>}

                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>City <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.snailCity ? "is-invalid" : ""}`}
                                                                type="text" value={snailCity} placeholder="Enter City" onChange={(e) => {
                                                                    setSnailCity(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, snailCity: "" }));
                                                                }} />
                                                            {errors.snailCity && <p className="error-text">{errors.snailCity}</p>}

                                                        </div>
                                                        <div className="col">
                                                            <label>State <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.snailState ? "is-invalid" : ""}`}
                                                                type="text" value={snailState} placeholder="Enter State"
                                                                onChange={(e) => {
                                                                    setSnailState(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, snailState: "" }));
                                                                }} />
                                                            {errors.snailState && <p className="error-text">{errors.snailState}</p>}

                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col-md-6">
                                                            <label>Zip <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.snailZip ? "is-invalid" : ""}`}
                                                                type="text" value={snailZip} placeholder="Enter Zip"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                                    setSnailZip(value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, snailZip: "" }));
                                                                }} />
                                                            {errors.snailZip && <p className="error-text">{errors.snailZip}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            {/* ======================
                                        DROP OFF HANDLING
                                    ======================= */}
                                            {reqMethod === "dropoff" && (
                                                <div className="section-card mt-3">
                                                    <label>Email <span style={{ color: "red" }}>*</span></label>

                                                    {dropOffEmails.map((mail, index) => (
                                                        <div
                                                            className="multi-row"
                                                            key={index}
                                                        >
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control inp ${errors[`dropOffEmail_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text"
                                                                    placeholder="Enter Email"
                                                                    value={mail}
                                                                    onChange={(e) => {
                                                                        const list = [...dropOffEmails];
                                                                        list[index] = e.target.value;
                                                                        setDropOffEmails(list);
                                                                        markDirty();
                                                                        clearFieldError(`dropOffEmail_${index}`);

                                                                    }}
                                                                    style={{ flex: 1 }}
                                                                />
                                                                {errors[`dropOffEmail_${index}`] && (
                                                                    <p className="error-text">{errors[`dropOffEmail_${index}`]}</p>
                                                                )}
                                                            </div>
                                                            <div className="icon-col">

                                                                {dropOffEmails.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeDropoffEmail(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}

                                                                {index === dropOffEmails.length - 1 && (
                                                                    <FaPlus
                                                                        className="icon-add"
                                                                        onClick={addDropoffEmail}
                                                                        style={{ cursor: "pointer", color: "#09c" }}
                                                                    />
                                                                )}
                                                            </div>

                                                        </div>

                                                    ))}

                                                    {/* Remaining Drop-Off fields */}
                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>Name <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.dropName ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={dropName}
                                                                placeholder="Enter Name"
                                                                onChange={(e) => {
                                                                    setDropName(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, dropName: "" }));
                                                                }}
                                                            />
                                                            {errors.dropName && <p className="error-text">{errors.dropName}</p>}

                                                        </div>

                                                        <div className="col">
                                                            <label>Address <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.dropAddress ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={dropAddress}
                                                                placeholder="Enter Address"
                                                                onChange={(e) => {
                                                                    setDropAddress(e.target.value);
                                                                    markDirty();
                                                                    setErrors((prev) => ({ ...prev, dropAddress: "" }));
                                                                }} />
                                                            {errors.dropAddress && <p className="error-text">{errors.dropAddress}</p>}

                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>City <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.dropCity ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={dropCity}
                                                                placeholder="Enter City"
                                                                onChange={(e) => {
                                                                    setDropCity(e.target.value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, dropCity: "" }));
                                                                }} />
                                                            {errors.dropCity && <p className="error-text">{errors.dropCity}</p>}

                                                        </div>
                                                        <div className="col">
                                                            <label>State <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.dropState ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={dropState}
                                                                placeholder="Enter State"
                                                                onChange={(e) => {
                                                                    setDropState(e.target.value);
                                                                    markDirty();
                                                                    clearFieldError("dropState")
                                                                }}
                                                            />
                                                            {errors.dropState && <p className="error-text">{errors.dropState}</p>}

                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col-md-6">
                                                            <label>Zip <span style={{ color: "red" }}>*</span></label>
                                                            <input
                                                                className={`form-control inp ${errors.dropZip ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={dropZip}
                                                                placeholder="Enter Zip"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                                    setDropZip(value);
                                                                    markDirty();
                                                                    clearFieldError("dropZip")
                                                                }}
                                                            />
                                                            {errors.dropZip && <p className="error-text">{errors.dropZip}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            {/* ======================
                                        AGENCY WEBSITE HANDLING
                                    ======================= */}
                                            {reqMethod === "agenweb" && (
                                                <div className="section-card mt-3">
                                                    <label>Email <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        className={`form-control inp ${errors.agenEmail ? "is-invalid" : ""}`}
                                                        type="text" placeholder="Enter Email" value={agenEmail} onChange={(e) => {
                                                            setAgenEmail(e.target.value);
                                                            markDirty();
                                                            clearFieldError("agenEmail")
                                                        }} />
                                                    {errors.agenEmail && <p className="error-text">{errors.agenEmail}</p>}

                                                    <label>Request Website URL <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        className={`form-control inp ${errors.agenUrl ? "is-invalid" : ""}`}
                                                        type="text" placeholder="Enter URL" value={agenUrl} onChange={(e) => {
                                                            setAgenUrl(e.target.value);
                                                            markDirty();
                                                            clearFieldError("agenUrl")
                                                        }} />
                                                    {errors.agenUrl && <p className="error-text">{errors.agenUrl}</p>}

                                                    <label>Description <span style={{ color: "red" }}>*</span></label>
                                                    <textarea
                                                        className={`form-control inp ${errors.agenDescription ? "is-invalid" : ""}`}
                                                        rows="3" placeholder="Enter Description" value={agenDescription} onChange={(e) => {
                                                            setAgenDescription(e.target.value);
                                                            markDirty();
                                                            clearFieldError("agenDescription")
                                                        }} />
                                                    {errors.agenDescription && <p className="error-text">{errors.agenDescription}</p>}

                                                </div>
                                            )}

                                            {/* ======================
                                             CRASHDOCX HANDLING
                                        ======================= */}
                                            {reqMethod === "crashdocx" && (
                                                <div className="section-card mt-3">
                                                    <label>Email <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        className={`form-control inp ${errors.crashEmail ? "is-invalid" : ""}`}
                                                        type="text" placeholder="Enter Email" value={crashEmail} onChange={(e) => {
                                                            setcrashEmail(e.target.value);
                                                            markDirty();
                                                            clearFieldError("agenDescription")
                                                        }} />
                                                    {errors.crashEmail && <p className="error-text">{errors.crashEmail}</p>}

                                                    <label>Request Website URL <span style={{ color: "red" }}>*</span></label>
                                                    <input
                                                        className={`form-control inp ${errors.crashUrl ? "is-invalid" : ""}`}
                                                        type="text" placeholder="Enter URL" value={crashUrl} onChange={(e) => {
                                                            setcrashUrl(e.target.value);
                                                            markDirty();
                                                            clearFieldError("crashUrl")
                                                        }} />
                                                    {errors.crashUrl && <p className="error-text">{errors.crashUrl}</p>}

                                                    <label>Description <span style={{ color: "red" }}>*</span></label>
                                                    <textarea
                                                        className={`form-control inp ${errors.crashDescription ? "is-invalid" : ""}`}
                                                        rows="3" placeholder="Enter Description" value={crashDescription} onChange={(e) => {
                                                            setcrashDescription(e.target.value);
                                                            markDirty();
                                                            clearFieldError("crashDescription")
                                                        }} />
                                                    {errors.crashDescription && <p className="error-text">{errors.crashDescription}</p>}

                                                </div>
                                            )}
                                        </div>
                                        {errors.reqMethodError && <p className="error-text">{errors.reqMethodError}</p>}

                                        {/* ==========================================
                                            RESPONSE METHOD
                                        ========================================== */}
                                        <div className="request-box mt-3">
                                            <label className="section-title">Response Method  <span style={{ color: "red" }}>*</span>
                                            </label>

                                            <div className="radio-group-add  mb-2">
                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "fax"} onChange={() => { handleResMethodChange("fax"); clearFieldError("responseMethodError") }} />{" "}  Fax
                                                </label>

                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "email"} onChange={() => { handleResMethodChange("email"); clearFieldError("responseMethodError") }} />{" "} Email
                                                </label>
                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "pickup"} onChange={() => { handleResMethodChange("pickup"); clearFieldError("responseMethodError") }} />{" "}  Pick Up
                                                </label>
                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "snailmail"} onChange={() => { handleResMethodChange("snailmail"); clearFieldError("responseMethodError") }} />{" "}  Snail Mail
                                                </label>
                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "agenweb"} onChange={() => { handleResMethodChange("agenweb"); clearFieldError("responseMethodError") }} />{" "} Request on Agency Website
                                                </label>
                                                <label>
                                                    <input type="radio" name="responseMethod" checked={responseMethod === "crashdocs"} onChange={() => { handleResMethodChange("crashdocs"); clearFieldError("responseMethodError") }} />{" "} CrashDocs
                                                </label>
                                            </div>

                                            {/* {responseMethod === "fax" && (
                                                <div className="section-card mt-3">
                                                    <label>Fax Numbers </label>

                                                    {resFaxList.map((resFax, index) => (
                                                        <div className="multi-row" key={index}>
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control ${errors[`resFax_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text"
                                                                    placeholder="Enter Fax Number"
                                                                    value={resFax}                            
                                                                    onChange={(e) => {
                                                                        const updated = [...resFaxList];
                                                                        updated[index] = e.target.value;
                                                                        setResFaxList(updated);
                                                                        markDirty();

                                                                        clearFieldError(`resFax_${index}`);
                                                                    }}
                                                                    style={{ flex: 1 }}
                                                                />


                                                            </div>

                                                            <div className="icon-col">
                                                                {resFaxList.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeResFax(index)}
                                                                        style={{ cursor: "pointer", color: "#f00" }}
                                                                    />
                                                                )}
                                                                {index === resFaxList.length - 1 && (
                                                                    <FaPlus
                                                                        className="icon-add"
                                                                        onClick={addResFax}
                                                                        style={{ cursor: "pointer", color: "#09c" }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )} 


                                            {responseMethod === "email" && (
                                                <div className="section-card mt-3">
                                                    <label>Email Addresses </label>

                                                    {resEmailList.map((resEmail, index) => (
                                                        <div className="multi-row" key={index}>
                                                            <div className="input-col">
                                                                <input
                                                                    type="email"
                                                                    placeholder="Email"
                                                                    value={resEmail}                              
                                                                    onChange={(e) => {
                                                                        const updated = [...resEmailList];
                                                                        updated[index] = e.target.value;
                                                                        setResEmailList(updated);
                                                                        markDirty();

                                                                        clearFieldError(`resEmail_${index}`);
                                                                    }}
                                                                    className={`form-control ${errors[`resEmail_${index}`] ? "is-invalid" : ""}`}
                                                                    style={{ flex: 1 }}
                                                                />

                                                            </div>

                                                            <div className="icon-col">
                                                                {resEmailList.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeResEmail(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}

                                                                {index === resEmailList.length - 1 && (
                                                                    <FaPlus
                                                                        className="icon-add"
                                                                        onClick={addResEmail}
                                                                        style={{ cursor: "pointer", color: "#09c" }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}



                                            {responseMethod === "snailmail" && (
                                                <div className="section-card mt-3">
                                                    <label>Email </label>

                                                    {resSnailEmailList.map((resMail, index) => (
                                                        <div className="multi-row" key={index}>
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control inp ${errors[`resSnailEmail_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text"
                                                                    placeholder="Enter Email"
                                                                    value={resMail}
                                                                    onChange={(e) => {
                                                                        const list = [...resSnailEmailList];
                                                                        list[index] = e.target.value;
                                                                        setResSnailEmailList(list);
                                                                        markDirty();

                                                                        clearFieldError(`resSnailEmail_${index}`);
                                                                    }}
                                                                    style={{ flex: 1 }}
                                                                />
                                                                {errors[`resSnailEmail_${index}`] && (
                                                                    <p className="error-text">{errors[`resSnailEmail_${index}`]}</p>
                                                                )}
                                                            </div>

                                                            <div className="icon-col">
                                                                {resSnailEmailList.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeResSnailEmail(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}
                                                                {index === resSnailEmailList.length - 1 && (
                                                                    <FaPlus className="icon-add" onClick={addResSnailEmail} style={{ cursor: "pointer" }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>Name </label>
                                                            <input
                                                                type="text"
                                                                className={`form-control inp ${errors.resSnailName ? "is-invalid" : ""}`}
                                                                value={resSnailName}
                                                                placeholder="Enter Name"
                                                                onChange={(e) => {
                                                                    setResSnailName(e.target.value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, resSnailName: "" }));
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col">
                                                            <label>Address </label>
                                                            <input
                                                                className={`form-control inp ${errors.resSnailAddress ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resSnailAddress}
                                                                placeholder="Enter Address"
                                                                onChange={(e) => {
                                                                    setResSnailAddress(e.target.value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, resSnailAddress: "" }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>City </label>
                                                            <input
                                                                className={`form-control inp ${errors.resSnailCity ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resSnailCity}
                                                                placeholder="Enter City"
                                                                onChange={(e) => {
                                                                    setResSnailCity(e.target.value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, resSnailCity: "" }));
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col">
                                                            <label>State </label>
                                                            <input
                                                                className={`form-control inp ${errors.resSnailState ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resSnailState}
                                                                placeholder="Enter State"
                                                                onChange={(e) => {
                                                                    setResSnailState(e.target.value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, resSnailState: "" }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col-md-6">
                                                            <label>Zip </label>
                                                            <input
                                                                className={`form-control inp ${errors.resSnailZip ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resSnailZip}
                                                                placeholder="Enter Zip"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                                    setResSnailZip(value);
                                                                    markDirty();

                                                                    setErrors((prev) => ({ ...prev, resSnailZip: "" }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {responseMethod === "pickup" && (
                                                <div className="section-card mt-3">
                                                    <label>Email </label>

                                                    {resPickupEmails.map((mail, index) => (
                                                        <div className="multi-row" key={index}>
                                                            <div className="input-col">
                                                                <input
                                                                    className={`form-control inp ${errors[`resPickupEmail_${index}`] ? "is-invalid" : ""}`}
                                                                    type="text"
                                                                    placeholder="Enter Email"
                                                                    value={mail}
                                                                    onChange={(e) => {
                                                                        const list = [...resPickupEmails];
                                                                        list[index] = e.target.value;
                                                                        setResPickupEmails(list);
                                                                        markDirty();

                                                                        clearFieldError(`resPickupEmail_${index}`);
                                                                    }}
                                                                    style={{ flex: 1 }}
                                                                />
                               
                                                            </div>

                                                            <div className="icon-col">
                                                                {resPickupEmails.length > 1 && (
                                                                    <FaTimes
                                                                        className="icon-remove"
                                                                        onClick={() => removeResPickupEmail(index)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                )}

                                                                {index === resPickupEmails.length - 1 && (
                                                                    <FaPlus
                                                                        className="icon-add"
                                                                        onClick={addResPickupEmail}
                                                                        style={{ cursor: "pointer", color: "#09c" }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>Name </label>
                                                            <input
                                                                className={`form-control inp ${errors.resPickupName ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resPickupName}
                                                                placeholder="Enter Name"
                                                                onChange={(e) => {
                                                                    setResPickupName(e.target.value);
                                                                    markDirty();
                                                                    setErrors(prev => ({ ...prev, resPickupName: "" }));
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col">
                                                            <label>Address </label>
                                                            <input
                                                                className={`form-control inp ${errors.resPickupAddress ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resPickupAddress}
                                                                placeholder="Enter Address"
                                                                onChange={(e) => {
                                                                    setResPickupAddress(e.target.value);
                                                                    markDirty();
                                                                    setErrors(prev => ({ ...prev, resPickupAddress: "" }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col">
                                                            <label>City </label>
                                                            <input
                                                                className={`form-control inp ${errors.resPickupCity ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resPickupCity}
                                                                placeholder="Enter City"
                                                                onChange={(e) => {
                                                                    setResPickupCity(e.target.value);
                                                                    markDirty();
                                                                    setErrors(prev => ({ ...prev, resPickupCity: "" }));
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col">
                                                            <label>State </label>
                                                            <input
                                                                className={`form-control inp ${errors.resPickupState ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resPickupState}
                                                                placeholder="Enter State"
                                                                onChange={(e) => {
                                                                    setResPickupState(e.target.value);
                                                                    markDirty();
                                                                    clearFieldError("resPickupState");
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-row">
                                                        <div className="col-md-6">
                                                            <label>Zip </label>
                                                            <input
                                                                className={`form-control inp ${errors.resPickupZip ? "is-invalid" : ""}`}
                                                                type="text"
                                                                value={resPickupZip}
                                                                placeholder="Enter Zip"
                                                                onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                                                    setResPickupZip(value);
                                                                    markDirty();
                                                                    clearFieldError("resPickupZip");
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                            )}

                                            {responseMethod === "agenweb" && (
                                                <div className="section-card mt-3">
                                                    <label>Email </label>
                                                    <input
                                                        className={`form-control inp ${errors.resAgenEmail ? "is-invalid" : ""}`}
                                                        type="text"
                                                        placeholder="Enter Email"
                                                        value={resAgenEmail}
                                                        onChange={(e) => {
                                                            setResAgenEmail(e.target.value);
                                                            markDirty();
                                                            clearFieldError("resAgenEmail");
                                                        }}
                                                    />

                                                    <label>Request Website URL </label>
                                                    <input
                                                        className={`form-control inp ${errors.resAgenUrl ? "is-invalid" : ""}`}
                                                        type="text"
                                                        placeholder="Enter URL"
                                                        value={resAgenUrl}
                                                        onChange={(e) => {
                                                            setResAgenUrl(e.target.value);
                                                            markDirty();
                                                            clearFieldError("resAgenUrl");
                                                        }}
                                                    />

                                                    <label>Description </label>
                                                    <textarea
                                                        className={`form-control inp ${errors.resAgenDescription ? "is-invalid" : ""}`}
                                                        rows="3"
                                                        placeholder="Enter Description"
                                                        value={resAgenDescription}
                                                        onChange={(e) => {
                                                            setResAgenDescription(e.target.value);
                                                            markDirty();
                                                            clearFieldError("resAgenDescription");
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            {responseMethod === "crashdocs" && (
                                                <div className="section-card mt-3">

                                                    <label>Email </label>
                                                    <input
                                                        className={`form-control inp ${errors.resCrashEmail ? "is-invalid" : ""}`}
                                                        type="text"
                                                        placeholder="Enter Email"
                                                        value={resCrashEmail}
                                                        onChange={(e) => {
                                                            setResCrashEmail(e.target.value);
                                                            markDirty();

                                                            clearFieldError("resCrashEmail");
                                                        }}
                                                    />

                                                    <label>Request Website URL </label>
                                                    <input
                                                        className={`form-control inp ${errors.resCrashUrl ? "is-invalid" : ""}`}
                                                        type="text"
                                                        placeholder="Enter URL"
                                                        value={resCrashUrl}
                                                        onChange={(e) => {
                                                            setResCrashUrl(e.target.value);
                                                            markDirty();
                                                            clearFieldError("resCrashUrl");
                                                        }}
                                                    />

                                                    <label>Description </label>
                                                    <textarea
                                                        className={`form-control inp ${errors.resCrashDescription ? "is-invalid" : ""}`}
                                                        rows="3"
                                                        placeholder="Enter Description"
                                                        value={resCrashDescription}
                                                        onChange={(e) => {
                                                            setResCrashDescription(e.target.value);
                                                            markDirty();

                                                            clearFieldError("resCrashDescription");
                                                        }}
                                                    />


                                                </div>
                                            )} */}


                                        </div>
                                        {errors.responseMethodError && <p className="error-text">{errors.responseMethodError}</p>}
                                        <div className="request-box mt-3">
                                            <label className="section-title">Trigger Events <span style={{ color: "red" }}>*</span></label>

                                            <div className="section-card ">
                                                {triggerEvents.map((trigger, index) => (
                                                    <div className="trigger-row" key={index}>

                                                        {/* Days Count */}
                                                        <div className="field-col">
                                                            <label>Wait Days Count </label>
                                                            <input
                                                                className={`form-control ${errors[`waitDaysError_${index}`] ? "is-invalid" : trigger.waitDays ? "" : ""}`}
                                                                type="number"
                                                                placeholder="Enter Days Count"
                                                                value={trigger.waitDays}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => {
                                                                    let value = e.target.value;

                                                                    // Allow empty input
                                                                    if (value === "") {
                                                                        const list = [...triggerEvents];
                                                                        list[index].waitDays = "";
                                                                        setTriggerEvents(list);
                                                                        markDirty();

                                                                        clearFieldError(`waitDaysError_${index}`);
                                                                        return;
                                                                    }

                                                                    // ❌ Strictly block anything except digits (0–9). This blocks: 01-101-101...
                                                                    if (!/^[0-9]+$/.test(value)) {
                                                                        return;
                                                                    }

                                                                    // Convert to number (now safe)
                                                                    value = Number(value);
                                                                    if (value < 1) return;
                                                                    // Save valid value
                                                                    const list = [...triggerEvents];
                                                                    list[index].waitDays = value;
                                                                    setTriggerEvents(list);
                                                                    markDirty();

                                                                    clearFieldError(`waitDaysError_${index}`);
                                                                }}

                                                            />
                                                            {errors[`waitDaysError_${index}`] && (
                                                                <p className="error-text">{errors[`waitDaysError_${index}`]}</p>
                                                            )}
                                                        </div>

                                                        {/* Action */}
                                                        <div className="field-col">
                                                            <label>Action </label>
                                                            <select
                                                                className={`form-select ${errors[`actionError_${index}`] ? "is-invalid" : ""}`}
                                                                value={trigger.action}
                                                                onChange={(e) => {
                                                                    const list = [...triggerEvents];
                                                                    list[index].action = e.target.value;
                                                                    setTriggerEvents(list);
                                                                    markDirty();

                                                                    clearFieldError(`actionError_${index}`);
                                                                }}
                                                                required
                                                            >
                                                                <option value="" >
                                                                    Select Action
                                                                </option>
                                                                <option value="Send Email">Send Email</option>
                                                                <option value="Phone Call">Phone Call</option>
                                                            </select>
                                                            {errors[`actionError_${index}`] && (
                                                                <p className="error-text">{errors[`actionError_${index}`]}</p>
                                                            )}
                                                        </div>

                                                        {/* Icons */}
                                                        <div className={`icon-col-trig ${errors[`waitDaysError_${index}`] || errors[`actionError_${index}`]
                                                            ? ""
                                                            : ""
                                                            }`}>
                                                            {triggerEvents.length > 1 && (
                                                                <FaTimes
                                                                    className="icon-remove"
                                                                    onClick={() => {
                                                                        const list = triggerEvents.filter((_, i) => i !== index);
                                                                        setTriggerEvents(list);
                                                                        markDirty();
                                                                    }}
                                                                />
                                                            )}
                                                            {index === triggerEvents.length - 1 && (
                                                                <FaPlus
                                                                    className="icon-add"
                                                                    onClick={() =>
                                                                        setTriggerEvents([...triggerEvents, { waitDays: "", action: "" }])
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                        {/* ==========================================
                                            FREQUENCY
                                        ========================================== */}
                                        <div className="request-box mt-3">
                                            <label className="section-title">Request Frequency <span style={{ color: "red" }}>*</span></label>

                                            <div className="frequency-row">
                                                {/* Weekly / Odd / Even */}
                                                {["Weekly", "OddWeekly", "EvenWeekly"].map((type) => (
                                                    <label key={type} style={{ display: "flex", alignItems: "center", gap: "7px", cursor: "pointer" }}>
                                                        <input
                                                            type="radio"
                                                            checked={frequencyType === type}
                                                            onChange={() => handleFrequencyChange(type)}

                                                        />{" "}
                                                        {type === "OddWeekly" ? "Odd Weekly" : type === "EvenWeekly" ? "Even Weekly" : "Weekly"}
                                                    </label>
                                                ))}

                                                {/* Monthly Radio with Dropdown */}
                                                <div style={{ position: "relative" }} ref={dropdownRef}>
                                                    <label style={{ display: "flex", alignItems: "center", gap: "7px", cursor: "pointer" }}>
                                                        <input
                                                            type="radio"
                                                            checked={frequencyType === "Monthly"}
                                                            onClick={() => {
                                                                // Toggle if clicking again
                                                                if (frequencyType === "Monthly") {
                                                                    setShowMonthDropdown(prev => !prev);
                                                                }
                                                            }}
                                                            onChange={() => {
                                                                setShowMonthDropdown(true);
                                                                handleFrequencyChange("Monthly");
                                                            }}

                                                        />

                                                        {" "}Monthly
                                                    </label>

                                                    {/* Monthly Dropdown */}
                                                    {frequencyType === "Monthly" && showMonthDropdown && (
                                                        <div
                                                            className="month-dropdown"
                                                            style={{
                                                                position: "absolute",
                                                                top: "100%",
                                                                left: "0",
                                                                marginTop: "8px",
                                                                width: "180px",
                                                                background: "white",
                                                                border: "1px solid #ccc",
                                                                borderRadius: "6px",
                                                                padding: "10px",
                                                                maxHeight: "250px",
                                                                overflowY: "auto",
                                                                zIndex: 1000,
                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                                                            }}
                                                        >
                                                            <div style={{ fontWeight: "500", marginBottom: "8px", fontSize: "14px" }}>Select dates</div>
                                                            {monthDays.map((day) => (
                                                                <label
                                                                    key={day}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px",
                                                                        padding: "4px 0",
                                                                        cursor: "pointer",
                                                                        fontSize: "14px"
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedMonthDays.includes(day)}
                                                                        onChange={() => toggleMonthDay(day)}
                                                                    />
                                                                    {day}
                                                                </label>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Section Card: Selected Values */}
                                            {["Weekly", "OddWeekly", "EvenWeekly"].includes(frequencyType) && (
                                                <div className="section-card mt-3">
                                                    <label>Select Week Days</label>
                                                    <div className="checkbox-group mt-2" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                        {weekdays.map((day) => (
                                                            <label key={day}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedWeekDays.includes(day)}
                                                                    onChange={() => {
                                                                        toggleWeekDay(day);
                                                                        markDirty();
                                                                        clearFieldError("frequency")
                                                                    }} />{" "}
                                                                {day}
                                                            </label>
                                                        ))}
                                                    </div>
                                                    {selectedWeekDays.length > 0 && (
                                                        <div className="selected-days mt-2">
                                                            <strong>Selected Days:</strong> {selectedWeekDays.join(", ")}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {frequencyType === "Monthly" && selectedMonthDays.length > 0 && (
                                                <div className="section-card mt-3">
                                                    <strong>Selected Month Days:</strong> {selectedMonthDays.sort((a, b) => a - b).join(", ")}
                                                </div>
                                            )}
                                            {errors.frequency && (<p className="error-text mt-2">{errors.frequency}</p>)}
                                            <div className="time-field mt-3">
                                                <label>Time </label>
                                                <input
                                                    type="time"
                                                    className="inp"
                                                    value={`${time || "00"}:00`} // always show :00
                                                    step={3600} // step by 1 hour
                                                    onChange={e => {
                                                        const hour = e.target.value.split(":")[0]; // get only hour
                                                        setTime(hour);
                                                        markDirty();

                                                        clearFieldError("time");
                                                    }}
                                                />
                                            </div>


                                            {errors.time && (<p className="error-text">{errors.time}</p>)}
                                        </div>

                                        {/* ==========================================
                                    DATE RANGE
                                ========================================== */}
                                        <div className="request-box mt-3">
                                            <label className="section-title">Request Date Range <span style={{ color: "red" }}>*</span></label>

                                            <div className="section-card">
                                                <div className="date-range-row">

                                                    {/* OFFSET BEGINS */}
                                                    <div className="date-field">
                                                        <label>Offset Begins</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.FromError ? "is-invalid" : ""}`}
                                                            placeholder="Enter Offset Start Range"
                                                            value={dateRange.from}
                                                            onWheel={(e) => e.currentTarget.blur()}
                                                            onChange={e => {
                                                                let value = e.target.value;

                                                                // Allow empty input
                                                                if (value === "") {
                                                                    setDateRange({ ...dateRange, from: "" });
                                                                    clearFieldError("FromError");
                                                                    markDirty();
                                                                    return;
                                                                }


                                                                const numValue = Number(value);

                                                                // ❌ Prevent positive numbers
                                                                if (numValue > 0) {
                                                                    return;
                                                                }

                                                                // ✅ Allowed: negative numbers
                                                                setDateRange({ ...dateRange, from: value });
                                                                markDirty();

                                                                clearFieldError("FromError");
                                                            }}
                                                        />
                                                        {errors.FromError && (
                                                            <p className="error-text">{errors.FromError}</p>
                                                        )}
                                                    </div>

                                                    {/* OFFSET ENDS */}
                                                    <div className="date-field">
                                                        <label>Offset Ends</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.ToError ? "is-invalid" : ""}`}
                                                            placeholder="Enter Offset End Range"
                                                            value={dateRange.to}
                                                            onWheel={(e) => e.currentTarget.blur()}
                                                            onChange={(e) => {
                                                                let raw = e.target.value;

                                                                // If empty → keep it empty (do NOT show 0)
                                                                if (raw === "") {
                                                                    setDateRange({ ...dateRange, to: "" });
                                                                    markDirty();

                                                                    clearFieldError("ToError");
                                                                    return;
                                                                }

                                                                let value = Number(raw);

                                                                // ❌ Not allowed: positive numbers
                                                                if (value > 0) {
                                                                    return;   // stop — do NOT set to 0
                                                                }
                                                                setDateRange({ ...dateRange, to: value });
                                                                markDirty();

                                                                clearFieldError("ToError");
                                                            }}


                                                        />
                                                        {errors.ToError && (
                                                            <p className="error-text">{errors.ToError}</p>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                    </div>

                                )}
                            </div>

                            <div className="accordion-item1">
                                <div className="accordion-header" onClick={() => toggleSection("callMailSettings")}>
                                    <span>Call and Mail Settings</span>
                                    <span>{openSection.includes("callMailSettings") ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
                                </div>
                                {openSection.includes("callMailSettings") && (
                                    <div className=" add-content">
                                        <div className="request-box">
                                            <div className="section-card">
                                                <div className="row">
                                                    <div className="form-group input-section col">
                                                        <label>Wait Days Before Sending Another Email <span style={{ color: "red" }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            // maxLength={5}
                                                            className={`form-control ${errors.waitDaysBeforeSendingEmail ? "is-invalid" : ""}`}
                                                            placeholder="Enter the number of wait days before sending email"
                                                            value={waitDaysBeforeSendingEmail}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, "");
                                                                setWaitDaysBeforeSendingEmail(value);
                                                                markDirty();
                                                                clearFieldError("waitDaysBeforeSendingEmail");
                                                            }}
                                                        />
                                                        {errors.waitDaysBeforeSendingEmail && (
                                                            <p className="error-text">{errors.waitDaysBeforeSendingEmail}</p>
                                                        )}
                                                    </div>
                                                    <div className="form-group input-section col">
                                                        <label>Wait Days Before Calling Again <span style={{ color: "red" }}>*</span></label>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            // maxLength={5}
                                                            className={`form-control ${errors.waitDaysBeforeCallingAgain ? "is-invalid" : ""}`}
                                                            placeholder="Enter the number of wait days before calling"
                                                            value={waitDaysBeforeCallingAgain}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/\D/g, "");
                                                                setWaitDaysBeforeCallingAgain(value);
                                                                markDirty();
                                                                clearFieldError("waitDaysBeforeCallingAgain");
                                                            }}
                                                        />
                                                        {errors.waitDaysBeforeCallingAgain && (
                                                            <p className="error-text">{errors.waitDaysBeforeCallingAgain}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {(isRequestBased || isCounterBased || isDateRangeBased) && (
                        <div className="save-btn-wrapper">
                            <button
                                className="agency-final-save-btn"
                                onClick={() => {
                                    console.log("Save button clicked");
                                    handleFinalSave();
                                }}
                            >
                                {isCloneMode ? "Add Agency" : mongoId ? "Update Agency" : "Save Agency"}
                            </button>
                        </div>
                    )}
                </div>

            </div>

        </div>
    );
};

export default AddAgency;
